export default __webpack_public_path__ + "static/media/sent-to-collections.fb04842f.svg";